import { CentralPerm } from '@enum/central/central-perm.enum';
import { LinkRoutes } from '@enum/central/link-routes.enum';

/**
 * Seção VENDAS do central (dono, 21/09/2026): Créditos saiu de Administrativo e
 * Certificados deixou de ser item solto na raiz. As rotas continuam as mesmas;
 * só as entradas do menu mudaram de lugar.
 */
export const SalesSection = [
  {
    section: 'Vendas',
    permission: ['*', CentralPerm.Credits_View, CentralPerm.Companies_View],
  },
  {
    title: 'Créditos',
    root: true,
    icon: 'account_balance_wallet',
    page: LinkRoutes.LIST_CREDITS,
    permission: ['*', CentralPerm.Credits_View],
    bullet: 'dot',
  },
  {
    title: 'Certificados',
    root: true,
    icon: 'description',
    page: '/admin/vendas-certificados',
    permission: ['*', CentralPerm.Companies_View],
    bullet: 'dot',
  },
];
